import { defaultSkyScrapper, IAdUnit } from "../unit";

export enum ProfilePageSkyscraperEnum {
  ProfilePageSkyscraperL1 = "Profile Page Skyscraper L1",
  ProfilePageSkyscraperR1 = "Profile Page Skyscraper R1",
}

export const ProfilePageSkyscraperUnits: { [name in ProfilePageSkyscraperEnum]: IAdUnit } = {
  [ProfilePageSkyscraperEnum.ProfilePageSkyscraperL1]: {
    ...defaultSkyScrapper,
    sid: "1232687",
  },
  [ProfilePageSkyscraperEnum.ProfilePageSkyscraperR1]: {
    ...defaultSkyScrapper,
    sid: "1232688",
  },
};
